<template>
  <el-card class="box-card full-screen cash-record-statistics">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            :picker-options="pickerOptions0"
            @change="changeDate"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-select
            v-model="queryForm.status"
            :placeholder="$t('all')"
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option :label="$t('checkPending')" value="0"></el-option>
            <el-option :label="$t('getApproved')" value="1"></el-option>
            <el-option :label="$t('notApproved')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>

      <el-row class="table-btns" v-if="loginInfo.orgType != 1">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-edit"
          @click="balanceApply"
          >{{ $t("addBalanceAdjustment") }}</el-button
        >
      </el-row>
    </div>

    <!-- Data Table -->
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="table.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="index"
          align="center"
          fixed="left"
          width="50"
        ></el-table-column>
        <el-table-column
          fixed="left"
          prop="createOrgInfoId"
          :label="$t('operateOrg')"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.createOrgName }} ({{ scope.row.createOrgInfoCode }})
          </template>
        </el-table-column>

        <el-table-column prop="amount" :label="$t('amount')" width="200">
          <template slot-scope="scope">
            <span class="franc">₣</span>{{ scope.row.amount.formatMoney(0) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="reason"
          :label="$t('reason')"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="status"
          :label="$t('Global validation')"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$t('Coordinator validation')"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$t('Admin validation')"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('creationTime')"
          width="150"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.createTime).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column
          prop="createLoginName"
          :label="$t('applyUser')"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.createLoginName }}
          </template>
        </el-table-column>

        <!-- Coodo -->
        <el-table-column
          prop="verifyUserCo"
          :label="$t('verifyUser')"
          min-width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyUserCo">{{
              scope.row.verifyUserCo
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyTimeCo"
          :label="$t('verifyTime')"
          min-width="150"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyTimeCo">{{
              $manba(scope.row.verifyTimeCo).format("ymdhms")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyRemarkCo"
          :label="$t('verifyRemark')"
          min-width="200"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyRemarkCo">{{
              scope.row.verifyRemarkCo
            }}</span>
          </template>
        </el-table-column>

        <!-- Admin -->
        <el-table-column
          prop="verifyUserAd"
          :label="$t('verifyUser')"
          min-width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyUserAd">{{
              scope.row.verifyUserAd
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyTimeAd"
          :label="$t('verifyTime')"
          min-width="150"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyTimeAd">{{
              $manba(scope.row.verifyTimeAd).format("ymdhms")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyRemarkAd"
          :label="$t('verifyRemark')"
          min-width="200"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyRemarkAd">{{
              scope.row.verifyRemarkAd
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          :label="$t('extend')"
          width="120"
          v-if="loginInfo.orgType == 1"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 0"
              type="primary"
              size="mini"
              @click="openCheckApply(scope.row)"
              >{{ $t("check") }}</el-button
            >
            <el-button v-else size="mini" disabled>{{ $t("check") }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--End Data Table-->
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="table.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t(applyTitle)"
      :visible.sync="isAddApply"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="500"
    >
      <el-form :model="applyForm" :rules="rules" ref="applyForm">
        <el-divider content-position="left">{{ $t("applyInfo") }}</el-divider>

        <el-form-item :label="$t('applyAmount')" prop="amount">
          <el-input size="medium" v-model="applyForm.amount"></el-input>
        </el-form-item>

        <el-form-item :label="$t('ApplyReason')" prop="reason">
          <el-input
            type="textarea"
            size="medium"
            v-model="applyForm.reason"
          ></el-input>
        </el-form-item>
        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="onSubmitAdd('applyForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>

    <!-- Check form-->
    <el-drawer
      :title="$t('balanceAdjustment')"
      :visible.sync="checkDrawer"
      direction="rtl"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="500"
    >
      <el-form :model="checkForm" :rules="rules" ref="checkForm">
        <el-form-item prop="id" style="display: none;">
          <el-input size="medium" v-model="checkForm.id" />
        </el-form-item>
        <el-form-item>
          <el-input size="medium" v-model="checkForm.receiveOrg" disabled />
        </el-form-item>

        <el-form-item :label="$t('applyAmount')" prop="amount">
          <el-input
            size="medium"
            v-model="checkForm.amount"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('ApplyReason')" prop="reason">
          <el-input
            type="textarea"
            size="medium"
            v-model="checkForm.reason"
            disabled
          ></el-input>
        </el-form-item>
        <el-divider content-position="left">{{ $t("checkInfo") }}</el-divider>
        <el-form-item :label="$t('checkStatus')" prop="status">
          <el-radio v-model="checkForm.status" :label="1" border>{{
            $t("getApproved")
          }}</el-radio>
          <el-radio v-model="checkForm.status" :label="2" border>{{
            $t("notApproved")
          }}</el-radio>
        </el-form-item>

        <el-form-item :label="$t('remark')" prop="verifyRemark">
          <el-input
            type="textarea"
            :rows="3"
            size="medium"
            v-model="checkForm.verifyRemark"
          ></el-input>
        </el-form-item>

        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="onSubmitCheck('checkForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
//import manba from '@/assets/uilt/manbaDate'
import card from "@/api/card";

export default {
  name: "balanceAdjustment",
  data() {
    return {
      //table高度，动态设置
      queryTableHeight: String,
      queryForm: {},
      checkForm: {},
      checkdrawer: false,

      isLoading: false,

      table: {},

      pageSize: 20,
      currentPage: 1,

      applyTitle: "addBalanceAdjustment",
      applyForm: {},

      isAddApply: false,
      checkDrawer: false,

      //禁用今天之后的日期选项
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: (time) => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },

    rules() {
      return {
        amount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        reason: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        //businessCode: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
      };
    },
  },

  watch: {
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = this.queryForm.date[0];
        this.queryForm.endTime = this.queryForm.date[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    },
  },

  methods: {
    getList() {
      let _this = this;
      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));
      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      } else {
        params.startTime = undefined;
        params.endTime = undefined;
      }
      delete params.date;

      card.pageBalanceAdjustment({
        param: {
          current: _this.table.currentPage,
          size: _this.table.pageSize,
          ...params,
        },
        success: (res) => {
          _this.table = res.data || {};
          _this.isLoading = false;
        },
      });
    },
    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
        this.pickerBeginDateBefore = {
          disabledDate: (time) => {
            let three = 3 * 30 * 24 * 3600 * 1000;
            if (this.minDate) {
              return (
                time.getTime() > Date.now() ||
                time > new Date(this.minDate.getTime() + three) ||
                time < new Date(this.minDate.getTime() - three)
              );
            }
            return time.getTime() > Date.now();
          },
        };
      }
    },
    openCheckApply(row) {
      this.checkDrawer = true;
      this.addForm = row;
      this.checkForm = {
        receiveOrg: row.getOrgName + " (" + row.getOrgInfoCode + ")",
        id: row.id,
        amount: row.amount,
        reason: row.reason,
      };
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    balanceApply() {
      this.isAddApply = true;
    },
    /**提交充值申请 */
    onSubmitAdd(refName) {
      let _this = this;

      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        _this.isLoading = true;
        card.addBalanceAdjustment({
          param: _this[refName],
          success: (res) => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.isAddApply = false;
              _this.getList();
            } else _this.$message.warning(_this.$t(res.msg));
          },
        });
      });
    },
    //onSubmitCheck
    onSubmitCheck(refName) {
      let _this = this;
      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        card.balanceAdjustmentCheck({
          param: _this[refName],
          success: (res) => {
            if (res.code == 200) {
              //_this.isVisible = false;
              this.checkDrawer = false;
              _this.getList();
              _this.$message.success(_this.$t("operateSuccessfully"));
            } else {
              _this.$message.warning(_this.$t(res.msg));
            }
          },
        });
      });
    },
  },
  mounted() {
    //console.log("Betto Component mounted");
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getList();
  },
};
</script>

<style lang="less" scoped></style>
